import axios from 'axios';
import { TokenLogout } from 'API/Logout/logout';

const url = process.env.REACT_APP_BACKEND_URL;
const Bankurl = process.env.REACT_APP_APPROVAL_URL

export const DsUserList = async (page, limit,setIsloading, setUserList, setErrorMsg, filter) => {
  setIsloading(true);
  console.log('filter', filter);

  try {
    await axios
      .post(
        `${url}/csp/ds/list?page=${page}&limit=${limit}`,
        {
          ...(filter.category === 'ds_name' && { ds_name: filter.search }),
          ...(filter.category === 'ds_code' && { ds_code: filter.search }),
          user_type: filter.user_type
        },
        {
          headers: {
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`

          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setUserList(res.data.ds_data);
          setIsloading(false);
        }
      })
      .catch((error) => {
        setErrorMsg(error.response ? error.response.data.error : 'Something went wrong');
        TokenLogout(error);
        setIsloading(false);
      });
  } catch (error) {
    setErrorMsg(error.response ? error.response.data.error : 'Something went wrong');
    TokenLogout(error);
    setIsloading(false);
  }
};

export const DsUserUpdate = async (Data, setIsloading, setSuccessMsg, setErrorMsg,setValueEdit,refunction) => {
  setIsloading(true);
  const formdata = new FormData();
  Object.entries(Data).map(([key, value]) => {
    formdata.append(key, value);
  });
  try {
    await axios
      .post(`${url}/csp/ds/update`, formdata, {
        headers: {
                  Authorization:`Bearer ${sessionStorage.getItem('token')}`

        }
      })
      .then((res) => {
        if (res.status === 200) {
          setSuccessMsg(res.data.message);
          setIsloading(false);
          setTimeout(() => {
            setValueEdit(false)
            refunction()
            sessionStorage.removeItem('request_id')
            sessionStorage.removeItem('BankAccVerified')
            sessionStorage.removeItem('od_ifsc_code')
            sessionStorage.removeItem('od_account_number')
            sessionStorage.removeItem('od_account_name')

          }, 1000);
        }
      })
      .catch((error) => {
        setErrorMsg(error.response ? error.response.data.error : 'Something went wrong');
        TokenLogout(error);
        setIsloading(false);
      });
  } catch (error) {
    setErrorMsg(error.response ? error.response.data.error : 'Something went wrong');
    TokenLogout(error);
    setIsloading(false);
  }
};

export const DsStatusUpdate = async (Data, userid, setIsloading, setSuccessMsg, setErrorMsg, setStatusData, handleClose, refunction) => {
    console.log("userid",userid);

  try {
    await axios
      .post(
        `${url}/csp/ds/status/update`,
        {
          'user_id': userid,
          'distributor_status': Data
        },
        {
          headers: {
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`

          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setSuccessMsg(res.data.message);
          setIsloading(false);
          setTimeout(() => {
            handleClose();
            setStatusData('')
            refunction()
          }, 1000);
        }
      })
      .catch((error) => {
        setErrorMsg(error.response ? error.response.data.error : 'Something went wrong');
        TokenLogout(error);
        setIsloading(false);
      });
  } catch (error) {
    setErrorMsg(error.response ? error.response.data.error : 'Something went wrong');
    TokenLogout(error);
    setIsloading(false);
  }
};

export const BankNames = async (setBankData) => {
  try {
    await axios
      .get(`${Bankurl}/banks`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          setBankData(res.data);
        }
      });
  } catch (error) {
    TokenLogout(error)
    console.log(error);
  }
};